import {
    
    REQUEST_STATE,
    CORE_AUTH_VERIFY_REQUEST,
    CORE_AUTH_VERIFY_SUCCESS,
    CORE_AUTH_VERIFY_FAILURE,
} from '../types'
const initialState = {
    user: null,
};

const requestState = REQUEST_STATE
export default {
    authen: (state = initialState, action) => {
        switch (action.type) {
            default:
                return {
                    ...state,
                };
        }
    },

    verifyLogin: (state = requestState, action) => {
        switch (action.type) {
            case CORE_AUTH_VERIFY_REQUEST:
                return state
            case CORE_AUTH_VERIFY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_AUTH_VERIFY_FAILURE:
                return []
            default:
                return state
        }
    },
};




// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerAuth.js